export default "__VITE_ASSET__DYHKX9xD__"